import { reset } from 'redux-form';

// Redux Action
//import { bookAViewingClose } from '../../../actions/bookAViewing/bookAViewingModal';
import { bookAViewing } from '../../../actions/bookAViewing/bookAViewing';


async function submit(values, dispatch) {
  //dispatch(bookAViewingClose());
  dispatch(bookAViewing(
    values.listId,
    values.hostId,
    values.hostEmail,
    values.name,
    values.companyName,
    values.email,
    values.phoneNumber,
    values.preferredDate,
    values.message
  ));
  dispatch(reset('BookAViewingForm'));
}

export default submit;



// WEBPACK FOOTER //
// src/components/ViewListing/BookAViewingModal/submit.js